module.exports = __webpack_public_path__ + "img/kunderejse-model.7812403d.png";